import api from './api';

const authService = {
  async login(email, password, options = {}) {
    const body = { email, password };
    if (options.skipSessionCookie) {
      body.skipSessionCookie = true;
    }
    const response = await api.post('/auth/login', body);
    if (response?.data) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response;
  },

  async syncSessionFromBearer(bearerToken) {
    await api.post(
      '/auth/session-cookie',
      {},
      { headers: { Authorization: `Bearer ${bearerToken}` } },
    );
  },

  async submitInquiry(data) {
    const response = await api.post('/inquiries', data);
    return response;
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('currentLocationId');
    }
  },

  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async updateProfile(data) {
    const response = await api.put('/auth/me', data);
    localStorage.setItem('user', JSON.stringify(response.data));
    return response.data;
  },

  async uploadAvatar(file) {
    const formData = new FormData();
    formData.append('avatar', file);
    const response = await api.put('/auth/me/avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    localStorage.setItem('user', JSON.stringify(response.data));
    return response.data;
  },

  async changePassword(currentPassword, newPassword) {
    return api.put('/auth/change-password', { currentPassword, newPassword });
  },

  async forgotPassword(email) {
    return api.post('/auth/forgot-password', { email });
  },

  async verifyResetOtp(email, otp) {
    return api.post('/auth/verify-reset-otp', { email, otp });
  },

  async resendOtp(email) {
    return api.post('/auth/resend-otp', { email });
  },

  async resetPassword(resetToken, password) {
    return api.post('/auth/reset-password', { resetToken, password });
  },

  async issueUrlAccessToken(payload) {
    const response = await api.post('/auth/url-access-token', payload);
    return response.data;
  },
};

export default authService;

